import React, { useEffect } from "react";
import { Box, VStack, Flex, Heading } from "@chakra-ui/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { testimonialsData } from "./testmonialData";
import { TestimonialCard } from "./TestmonialCard";

const Testimonials = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  const settings = {
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: true,
    swipeToSlide: true,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1 } },
    ],
  };

  const data = [...testimonialsData, ...testimonialsData];

  return (
    <Box id="testimonials">
      <VStack spacing={8} align="center">
        <Flex
          direction="column"
          align="center"
          w={{ base: "100%", lg: "60%" }}
          gap="24px"
          mb="40px"
        >
          <Heading
            color="#021A04"
            fontSize={{ base: "24px", md: "32px" }}
            fontWeight="550"
            textAlign="center"
          >
            Testimonials
          </Heading>
        </Flex>
        <Box w={{ base: "114%", lg: "100%" }}>
          <Slider {...settings}>
            {data.map((item, idx) => (
              <Box key={idx} px="8px">
                <TestimonialCard
                  testimonial={item.testimonial}
                  name={item.name}
                  image={item.image}
                  grade={item.grade}
                />
              </Box>
            ))}
          </Slider>
        </Box>
      </VStack>
    </Box>
  );
};

export default Testimonials;
